// extracted by mini-css-extract-plugin
export default {"linkButtonWrapper":"spinner_linkButtonWrapper__QEOmI","linkButton":"spinner_linkButton__CoubJ","ldsRing":"spinner_ldsRing__9ZmnZ","lds-ring":"spinner_lds-ring__hwW6z"};